/**
 * The game steps of the road as a small table (stepId → its bot, exam, colour) — what the shell's router needs to open a
 * path game link (`#/play?path=<step>`) without loading the chapters (fixer r1: the first load of a child without the
 * path). ./gameSteps.test.ts keeps it equal to the chapters' own game steps.
 */
import type { Color, PersonaId } from '@gambit/shared';

export interface PathGameStepInfo {
  persona: PersonaId;
  exam: boolean;
  color?: Color;
}

export const PATH_GAME_STEPS: Readonly<Record<string, PathGameStepInfo>> = {
  'reach-game': { persona: 'petya', exam: false },
  'gifts-game': { persona: 'sonya', exam: false },
  'save-game': { persona: 'sonya', exam: false },
  'trade-game': { persona: 'sonya', exam: false },
  'check-game': { persona: 'grisha', exam: false },
  'two-questions-exam': { persona: 'sonya', exam: true },
  'two-questions-exam-2': { persona: 'grisha', exam: true },
};

/** A game step of the road by id (undefined: not a game step). */
export function pathGameStep(stepId: string): PathGameStepInfo | undefined {
  return Object.hasOwn(PATH_GAME_STEPS, stepId) ? PATH_GAME_STEPS[stepId] : undefined;
}
